import type { JobRunInput, JobRunKind } from "@/features/job/job-run/jobRun.types";
import { toJobRunText } from "@/features/job/job-run/jobRun.utils";
import { JobRunBuildSnapshot } from "./JobRunBuildSnapshot";
import { toBuildSnapshotTarget } from "./jobRunBuildSnapshot.utils";

/** buildSnapshot in the run drawer. */
export const jobRunBuildSnapshot: JobRunKind = {
  Settings: JobRunBuildSnapshot,
  toInitialInput: (input) => {
    const initial: JobRunInput = {};
    const report = toJobRunText(input, "report");
    const date = toJobRunText(input, "date");
    if (report) initial.report = report;
    if (date) initial.date = date;
    return initial;
  },
  isComplete: (input) => toBuildSnapshotTarget(input) !== null,
};
